<template>
  <div class="index">
    <div class="content">
      <div class="info" style="margin-top:6px">
        <div class="left">客户姓名</div>
        <div class="right">{{ detailData.name }}</div>
      </div>
      <div class="info">
        <div class="left">手机号</div>
        <div class="right">{{ detailData.mobile }}</div>
      </div>
      <div class="info">
        <div class="left">业务类型</div>
        <div class="right">{{ detailData.serviceName }}</div>
      </div>
      <div class="info">
        <div class="left">预约支行</div>
        <div class="right">{{ detailData.bankName }}</div>
      </div>
      <div class="info">
        <div class="left">客户经理</div>
        <div class="right">{{ detailData.employeeName }}</div>
      </div>
      <div class="info">
        <div class="left">提交预约时间</div>
        <div class="right">{{ detailData.createdAt }}</div>
      </div>
      <div class="info">
        <div class="left">预约时间</div>
        <div class="right">{{ detailData.serviceTime }}</div>
      </div>
    </div>
    <div class="cancel" v-show="detailData.status == 1" @click="cancel(detailData.id)">代客取消</div>
    <div class="bottom" v-if="detailData.status == 1">
      <div class="bot_left" @click="daPhone">
        <div class="icon">
          <img src="../../assets/images/phone.png" alt="" />
        </div>
        <div class="li">联系客户</div>
      </div>
      <div class="bot_right" @click="completeService">完成服务</div>
    </div>
    <div class="lianxi" @click="daPhone" v-else>联系客户</div>
  </div>
</template>
  <script>
import { appointmentDetail, editStatus } from "../../api/appointment";
import { Dialog } from "vant";
export default {
  data() {
    return {
      detailData: "",
      id: "",
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.getDetail();
  },
  methods: {
    getDetail() {
      appointmentDetail({ id: this.id }).then((res) => {
        this.detailData = res.data;
      });
    },
    cancel(id) {
      Dialog.confirm({
        message: "确定代客取消？",
      })
        .then(() => {
          editStatus({ id, status: 0 }).then((res) => {
            if (res.code == 200) {
              this.$toast("成功取消！");
              this.getDetail();
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    daPhone() {
      window.location.href = `tel:${this.detailData.mobile}`;
    },
    completeService() {
      editStatus({ id: this.detailData.id, status: 2 }).then((res) => {
        if (res.code == 200) {
          this.$toast("成功完成！");
          this.getList();
        }
      });
    },
  },
};
</script>
    <style lang="less" scoped>
.content {
  font-size: 15px;
  color: #4a4a4a;
  overflow: auto;
  .info {
    display: flex;
    height: 38px;
    line-height: 36px;
  }
  .left {
    width: 104px;
    margin-left: 20px;
  }
}
.cancel {
  margin-top: 50px;
  text-align: center;
  width: 100%;
  height: 20px;
  color: #bbbbbb;
  font-size: 14px;
}
.bottom {
  width: 90%;
  height: 42px;
  position: fixed;
  left: 6%;
  bottom: 12px;
  display: flex;
  justify-content: space-between;
  .bot_left {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    img {
      width: 21px;
      height: 21px;
    }
    .li {
      margin-bottom: 12px;
      height: 14px;
      font-size: 10px;
      color: #c1c9d0;
      line-height: 14px;
    }
  }
  .bot_right {
    text-align: center;
    width: 279px;
    height: 42px;
    background: #2a8ff7;
    border-radius: 21px;
    font-size: 14px;
    font-weight: bold;
    color: #ffffff;
    line-height: 42px;
    letter-spacing: 1px;
  }
}
.lianxi {
  position: fixed;
  bottom: 12px;
  width: 94%;
  left: 3%;
  height: 42px;
  line-height: 42px;
  background: #2a8ff7;
  border-radius: 21px;
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  color: #ffffff;
  letter-spacing: 1px;
}
</style>